var map = {
	"./_stats": "S69Y",
	"./de_stats": "ine7",
	"./es_stats": "LkWJ",
	"./fr_stats": "HgZI",
	"./keto_stats": "JIKi",
	"./pt_stats": "V0ro"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "EckS";